import { gql } from '@apollo/client';
import TENANT_ELEMENT from 'api/fragments/TENANT_ELEMENT';
const ADD_TENANT_ELEMENT = gql `
  ${TENANT_ELEMENT}
  mutation AddTenantTemplateElement($tenantId: ID!, $name: String!) {
    addModelSpecificationTemplateElement(tenantId: $tenantId, name: $name) {
      modelSpecificationTemplateElement {
        ...TenantElementFragment
      }
    }
  }
`;
export default ADD_TENANT_ELEMENT;
